// Recursively finds and returns the table name associated with a given backend_key value

export const findTableForValue = (data: any, targetValue: any) => {
  const traverse: any = (nodes: any, parentWithTable = null) => {
    for (const node of nodes) {
      const currentParent = node.table || node.table_name ? node : parentWithTable;

      if (node.backend_key === targetValue) {
        return currentParent.table || currentParent.table_name || null;
      }

      if (node.children) {
        const found = traverse(node.children, currentParent);
        if (found) return found;
      }
    }

    return null;
  };

  return traverse(data);
};
